import { LOADING } from "../../../constants/constant";
import {
  SEND_MESSAGE_REQUESTED,
  SEND_MESSAGE_FAILED,
  SEND_MESSAGE_SUCCESS,
  SEND_MESSAGE_RESET
} from "../../actions/ActionType";

const initialState = {
  status: "INIT",
  isLoading: undefined,
};

export default function sendMessageReducer(state = initialState, action) {
  switch (action.type) {
    case SEND_MESSAGE_REQUESTED:
      let reqstState = Object.assign({}, state);
      reqstState.isLoading = true;
      reqstState.status = LOADING;
      return reqstState;

    case SEND_MESSAGE_SUCCESS:
      let userRes = Object.assign({}, state);
      userRes.status = action.data.status_message;
      userRes.statusCode = action.data.status_code;
      userRes.message = action.data.message;
      userRes.isLoading = false;
      console.log("response in send msg reducer :",userRes);
      return userRes;

    case SEND_MESSAGE_FAILED:
     
      let errorRes = Object.assign({}, state, action.data);
      errorRes.error=action.data
      errorRes.isLoading = false;
      console.error("Error while sending message", action.data);
      return errorRes;

      case SEND_MESSAGE_RESET: {
        return initialState;
      }
    default:
      return state;
  }
}
